
import { useParams } from 'react-router-dom';
import TableView from '../../GlobalComponents/TableView/TableView';

import { BiDownload  } from "react-icons/bi";

const data = [
  { Device: "ADM-FF-01", PROCESSS: "COMPLETED", TIME: "21st August, 2024 11:59:00 PM" },
  { Device: "ADM-FF-02", PROCESSS: "PROCESSING", TIME: "21st August, 2024 11:59:00 PM" },
  { Device: "ADM-FF-03", PROCESSS: "FAILED", TIME: "22nd August, 2024 12:10:00 AM" },
  { Device: "ADM-FF-04", PROCESSS: "COMPLETED", TIME: "22nd August, 2024 12:30:00 AM" },
  { Device: "ADM-FF-05", PROCESSS: "PROCESSING", TIME: "22nd August, 2024 01:00:00 AM" },
  { Device: "ADM-FF-06", PROCESSS: "FAILED", TIME: "22nd August, 2024 01:15:00 AM" },
  { Device: "ADM-FF-07", PROCESSS: "COMPLETED", TIME: "22nd August, 2024 02:00:00 AM" },
  { Device: "ADM-FF-08", PROCESSS: "PROCESSING", TIME: "22nd August, 2024 02:30:00 AM" },
  { Device: "ADM-FF-09", PROCESSS: "COMPLETED", TIME: "22nd August, 2024 03:00:00 AM" },
  { Device: "ADM-FF-10", PROCESSS: "FAILED", TIME: "22nd August, 2024 03:30:00 AM" },
  { Device: "ADM-FF-11", PROCESSS: "COMPLETED", TIME: "22nd August, 2024 04:00:00 AM" },
  { Device: "ADM-FF-12", PROCESSS: "PROCESSING", TIME: "22nd August, 2024 04:30:00 AM" },
  { Device: "ADM-FF-13", PROCESSS: "COMPLETED", TIME: "22nd August, 2024 05:00:00 AM" },
  { Device: "ADM-FF-14", PROCESSS: "FAILED", TIME: "22nd August, 2024 05:30:00 AM" },
  { Device: "ADM-FF-15", PROCESSS: "PROCESSING", TIME: "22nd August, 2024 06:00:00 AM" },
  { Device: "ADM-FF-16", PROCESSS: "COMPLETED", TIME: "22nd August, 2024 06:30:00 AM" },
  { Device: "ADM-FF-17", PROCESSS: "FAILED", TIME: "22nd August, 2024 07:00:00 AM" },
  { Device: "ADM-FF-18", PROCESSS: "COMPLETED", TIME: "22nd August, 2024 07:30:00 AM" },
  { Device: "ADM-FF-19", PROCESSS: "PROCESSING", TIME: "22nd August, 2024 08:00:00 AM" },
  { Device: "ADM-FF-20", PROCESSS: "FAILED", TIME: "22nd August, 2024 08:30:00 AM" },
  { Device: "ADM-FF-21", PROCESSS: "COMPLETED", TIME: "22nd August, 2024 09:00:00 AM" },
  { Device: "ADM-FF-22", PROCESSS: "PROCESSING", TIME: "22nd August, 2024 09:30:00 AM" },
  { Device: "ADM-FF-23", PROCESSS: "COMPLETED", TIME: "22nd August, 2024 10:00:00 AM" },
  { Device: "ADM-FF-24", PROCESSS: "FAILED", TIME: "22nd August, 2024 10:30:00 AM" },
  { Device: "ADM-FF-25", PROCESSS: "COMPLETED", TIME: "22nd August, 2024 11:00:00 AM" },
  { Device: "ADM-FF-26", PROCESSS: "PROCESSING", TIME: "22nd August, 2024 11:30:00 AM" },
  { Device: "ADM-FF-27", PROCESSS: "FAILED", TIME: "22nd August, 2024 12:00:00 PM" },
  { Device: "ADM-FF-28", PROCESSS: "COMPLETED", TIME: "22nd August, 2024 12:30:00 PM" },
  { Device: "ADM-FF-29", PROCESSS: "PROCESSING", TIME: "22nd August, 2024 01:00:00 PM" },
  { Device: "ADM-FF-30", PROCESSS: "FAILED", TIME: "22nd August, 2024 01:30:00 PM" }
];


const headers = [
  {
      key: 'Download',
      label: <BiDownload size={25}/>,
      render: (row) => (
          <button>
           <BiDownload size={25}/>
          </button>
      ),
  },
  {
    key: 'TIME',
    label: 'RUN NO',
},
{
  key: 'TIME',
  label: 'STATUS',
  render: (row) => (
      <span
      className={`inline-flex items-center justify-center  ${row.PROCESSS === `COMPLETED`? `text-green-600` : `text-red-600 `}`}>
          {row.PROCESSS === "COMPLETED"? "Successful" : "Failed"}

  </span>
  ),
 
},
{
  key: 'TIME',
  label: 'DESCRIPTION',
},


];
const DynamicNoti = () => {
  const { id } = useParams();
  return (
    <section className="bg-SoftBlack h-auto md:mt-0 md:pt-3 mt-16 ">
  <div className=' bg-DarkBlue   md:mx-16 mb-5 rounded-md overflow-x-scroll'>
  <table class="min-w-full  rounded-md text-white mb-5">
  <thead>
    <tr class="border-b border-gray-700">
      <th class="px-4 py-2 text-left text-gray-400">ROOm NO</th>
      <th class="px-4 py-2 text-left text-gray-400">STATUS</th>
      <th class="px-4 py-2 text-left text-gray-400">CONTROLLER/HOST</th>
      <th class="px-4 py-2 text-left text-gray-400">TYPE</th>
      <th class="px-4 py-2 text-left text-gray-400">MANUFACTURE</th>
      <th class="px-4 py-2 text-left text-gray-400">MODEL</th>
      <th class="px-4 py-2 text-left text-gray-400">DEVICE</th>
      <th class="px-4 py-2 text-left text-gray-400">PORT</th>
      <th class="px-4 py-2 text-left text-gray-400">BI-DIRECT</th>
    </tr>
  </thead>
  <tbody>
    <tr class="border-b border-gray-700 hover:bg-gray-700">
      
      <td class="px-4 py-2">{id}</td>
      <td class="px-4 py-2">n/a</td>
      <td class="px-4 py-2">10.80.77.47</td>
      <td class="px-4 py-2">Network Switch</td>
      <td class="px-4 py-2">amino</td>
      <td class="px-4 py-2">amino</td>
      <td class="px-4 py-2">amino-v1.0</td>
      <td class="px-4 py-2">IR</td>
      <td class="px-4 py-2">...</td>
    </tr>
 
  </tbody>
</table>

  </div>
    <TableView headers={headers} rows={data} />
    </section>
  );
}

export default DynamicNoti;